import React from 'react';
import BatteryFull from "@material-ui/icons/BatteryFull";
import Battery20 from "@material-ui/icons/Battery20";
import Battery60 from "@material-ui/icons/Battery60";
import PowerIcon from '@material-ui/icons/Power';
import BatteryUnknownIcon from '@material-ui/icons/BatteryUnknown';
import Tooltip from "@material-ui/core/Tooltip";

interface IPowerIconProps {
    show: boolean;
    supplyState: string;
}

export const PowerSupplyIcon = (props: IPowerIconProps) => {
    const { show, supplyState } = props;
    if (!show) {
        return null;
    }
    const tooltipText = 'Power';
    const COLOR_GREEN = '#31b800';
    const COLOR_BLUE = '#00acc1';
    const COLOR_YELLOW = '#ffe11c';
    const COLOR_RED = '#ff0000';

    switch (supplyState) {
        case 'battery_empty':
            return (
                <Tooltip title={tooltipText}>
                    <div style={{color: COLOR_RED}}>
                        <Battery20/>
                    </div>
                </Tooltip>
            );
        case 'battery_weak':
            return (
                <Tooltip title={tooltipText}>
                    <div style={{color: COLOR_YELLOW}}>
                        <Battery60/>
                    </div>
                </Tooltip>
            );
        case 'battery_good_normal':
            return (
                <Tooltip title={tooltipText}>
                    <div style={{color: COLOR_GREEN}}>
                        <BatteryFull/>
                    </div>
                </Tooltip>
            );
        case 'line':
            return (
                <Tooltip title={tooltipText}>
                    <div style={{color: COLOR_GREEN}}>
                        <PowerIcon/>
                    </div>
                </Tooltip>
            );
        default:
            return (
                <Tooltip title={tooltipText}>
                    <div style={{color: COLOR_BLUE}}>
                        <BatteryUnknownIcon/>
                    </div>
                </Tooltip>
            );
    }
};

export default PowerIcon;
